export function detectElementRemoved(element: HTMLElement, callback: () => void) {
  const checkIfRemoved = () => {
    if (!document.contains(element)) {
      callback();
      document.removeEventListener("htmx:beforeSwap", checkIfRemoved);
      document.removeEventListener("htmx:afterSwap", checkIfRemoved);
    }
  };

  document.addEventListener("htmx:beforeSwap", checkIfRemoved);
  document.addEventListener("htmx:afterSwap", checkIfRemoved);
}
